import * as React from 'react';

import * as styles from './locationField.css';

export const LocationField = ({
  location,
  time,
}: {
  location: React.ReactElement<any>;
  time: React.ReactElement<any>;
}): React.JSX.Element => {
  return (
    <div className={styles['content']}>
      <div>{location}</div>
      <div className={styles['time']}>{time}</div>
    </div>
  );
};
